import { Immutable } from "immer";
import React from "react";
import { jt } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { FORM_FIELD_SUBMIT_CLASS_NAME } from "../../../forms/classNames";
import { AccountContentTitle } from "../AccountContentTitle";
import { FormFields } from "../FormFields";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.PasswordResetConfirmDocumentTemplate>;

export const PasswordResetConfirmBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        valid_link,
        user_email,
        action_url,
        submit_text,
        invalid_heading,
        invalid_message,
    } = props;
    const emailLabel = (
        <span className="utility-page__text-blue">{user_email}</span>
    );
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    {valid_link ? (
                        <div className="my-account-form">
                            <p>{jt`Enter a new password for ${emailLabel}`}</p>
                            <form
                                id="password_reset_form"
                                className="js-kuid-form"
                                action={action_url}
                                method="post"
                            >
                                <CSRFToken />
                                <FormFields
                                    fields={props.fields}
                                    field_labels={props.field_labels}
                                    field_errors={props.field_errors}
                                    non_field_errors={props.non_field_errors}
                                />
                                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                    <input
                                        type="submit"
                                        className="button button--full-width"
                                        value={submit_text}
                                    />
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <h1>{invalid_heading}</h1>
                            <p>{invalid_message}</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
